import {Card} from "react-bootstrap";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import '../../styles/custom/HeroCardAlt.css';
import {useSelector} from "react-redux";

export const HeroCardAlt = (props) => {

    const customBg = props.disabled ? 'secondary' : props.active ? 'primary' : null

    const userPerms = useSelector(state => state.user?.permissions)


    const card = (
        <Card
            bg={customBg}
            className={props.active ? null : 'custom-card'}
            onClick={props.onClick}
            role={props.onClick ? 'button' : undefined}
            style={props.onClick ? {cursor: 'pointer'} : undefined}
        >
            <Card.Body
                className={props.active ? 'null' : 'hover'}
            >
                <div>
                    <div className={`text-${props.actionVariant}`}>
                        {props.icon}
                    </div>
                    <div className={'fs-4'}>{props.title}</div>
                </div>
            </Card.Body>
        </Card>
    )

    if (props.perms && !props?.perms.every(perm => Array.isArray(userPerms) ? userPerms.includes(perm) : userPerms?.[perm])) {
        return null;
    }

    return (
        props.actionLink ? (
            <Link className={'text-decoration-none'} to={props.actionLink} title={props.text}>
                {card}
            </Link>
        ) : (
            <div className={'text-decoration-none'} title={props.text}>
                {card}
            </div>
        )
    )
}


HeroCardAlt.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string.isRequired,
    actionLink: PropTypes.string,
    actionText: PropTypes.string,
    actionVariant: PropTypes.string,
    actionDisabled: PropTypes.bool,
    icon: PropTypes.node,
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    onClick: PropTypes.func,
    perms: PropTypes.array,

};
